import { shuffle } from 'lodash'

const letters = 'abcdefghijklmnopqrstuvwxyz'
const lettersUpperCase = letters.toLocaleUpperCase()
const numbers = '0123456789'
const characters = letters + lettersUpperCase + numbers

const getRandomNumber = (count: number): number => Math.floor(Math.random() * count)

export const generatePassword = (size = 6): string => {
  const patterns = [letters, lettersUpperCase, numbers, ...Array(size - 3).fill(characters)]
  const lettersArray = patterns.map((pattern) => pattern[getRandomNumber(pattern.length)])

  return shuffle(lettersArray).join('')
}
